export default __webpack_public_path__ + "static/blog1-945ee02c4db7cee879d1ea6b5a7b4aa6.jpg";